import * as React from 'react';
import { SVGProps } from 'react';

const SvgErecepty = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M8 1.5h14a1.5 1.5 0 0 1 0 3H8a1.5 1.5 0 1 1 0-3ZM2 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8 13.5h14a1.5 1.5 0 0 1 0 3H8a1.5 1.5 0 0 1 0-3ZM2 16.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8 7.5h14a1.5 1.5 0 0 1 0 3H8a1.5 1.5 0 1 1 0-3ZM2 10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8 19.5h14a1.5 1.5 0 0 1 0 3H8a1.5 1.5 0 0 1 0-3ZM2 22.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
      stroke="currentColor"
    />
  </svg>
);

export default SvgErecepty;
